// Add your custom JS here.



(function($){
    
    jQuery(document).ready(function($) {


        var ACCEPT_COOKIE_NAME = 'wp_lang';
        var ACCEPT_COOKIE_EXPIRE = 365;

        //console.log(jqcook);

            
        $('.SetCookieBtn').click(function (e) {
            var lang = $(this).data('lang');
            var url = $(this).data('url');

            //console.log(ACCEPT_COOKIE_NAME);
            //console.log(lang);
            
            jqcook(ACCEPT_COOKIE_NAME, lang, {
				expires: ACCEPT_COOKIE_EXPIRE,
				path: '/'
			});
            

            window.location.href = url;
            
        });

        function jqcook (key, value, options) {

            // key and at least value given, set cookie...
            if (arguments.length > 1 && (!/Object/.test(Object.prototype.toString.call(value)) || value === null || value === undefined)) {
                options = $.extend({}, options);
    
                if (value === null || value === undefined) {
                    options.expires = -1;
                }
    
                if (typeof options.expires === 'number') {
                    var days = options.expires,
                        t = options.expires = new Date();
                    t.setDate(t.getDate() + days);
                }
    
                value = String(value);
    
                return (document.cookie = [
                    encodeURIComponent(key), '=', options.raw ? value : encodeURIComponent(value),
                    options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                    options.path ? '; path=' + options.path : '',
                    options.domain ? '; domain=' + options.domain : '',
                    options.secure ? '; secure' : ''
                ].join(''));
            }
    
            // key and possibly options given, get cookie...
            options = value || {};
            var decode = options.raw ? function (s) {
                return s;
            } : decodeURIComponent;
    
            var pairs = document.cookie.split('; ');
            for (var i = 0, pair; pair === pairs[i] && pairs[i].split('='); i++) {
                if (decode(pair[0]) === key) {
                    // IE saves cookies with empty string as "c; ", e.g. without "=" as opposed to EOMB, thus pair[1] may be undefined
                    return decode(pair[1] || '');
                }
            }
            return null;
        };

       //console.log('logga qui');

        if(jQuery('.tabHash').length>0){
            
            var hash = window.location.hash;
            //hash && jQuery('.nav a[href="' + hash + '"]').tab('active');
            //console.log(hash);
            if (hash == '') {
            hash = jQuery('.tabHash').find('a.collapsed').attr('href');
            }
            //console.log(hash);
            jQuery('.tabHash').find(".collapse").removeClass("show");
            jQuery('.tabHash').find('.nav-tabs').removeClass("active");

            var tabIndex = jQuery('.tabHash').find('.nav-tabs[href="' + hash + '"]').data('target');
            //console.log(tabIndex);
            jQuery(tabIndex).addClass('show');
            
            jQuery('.nav-tabs').click(function (e) {
                //jQuery(this).tab('active');
                //var scrollmem = jQuery('body').scrollTop() || jQuery('html').scrollTop();
                window.location.hash = this.hash;
                jQuery('.tabHash').find(".collapse").removeClass("show");
                jQuery('.tabHash').find('.nav-tabs').removeClass("active");

                var tabIndex = jQuery(this).data('target');
                //console.log(tabIndex);
                jQuery(tabIndex).addClass('show');
                
                //jQuery('html,body').scrollTop(scrollmem);
            });
        }
        
        
        

       

        $('.SliderProdotto2023__wrap__items').on( "scroll", function(e) {
            e.preventDefault();
            e.stopPropagation();

            //console.log($('.SliderProdotto2023__wrap__items').scrollLeft() );
            return false;
            
        
        });
        var width_move = $('.SliderProdotto2023__wrap__items__category__item').outerWidth(true);
       
        $(document).on('click','.nav_slider li', function() {
            var $this = $(this);
            var parent = $(this).parents('.SliderProdotto2023');
            var parent_cat = $(this).parents('.SliderProdotto2023').find('.SliderProdotto2023__wrap__items .active');
            var current_item = parent_cat.find('.current');

            console.log(width_move);
            //console.log(current_item);
            
            //console.log(current_item.next());
            if($this.hasClass('button-prev')){
                //console.log('button_prev');
                if(current_item.prev().length == 1){
                    //console.log(current_item.prev());
                    var el = current_item.prev();

                    current_item.removeClass('current');
                    el.addClass('current');
                }else {

                    if (parent_cat.prev().length == 1) {
                        parent_cat.removeClass('active');
                        parent_cat = parent_cat.prev().addClass('active');
                        var parent_cat_id = parent_cat.data('catid');
                        $('.ListsProducts').find("[data-id='" + parent_cat_id + "']").addClass('active').siblings().removeClass('active');
                        var el = parent_cat.find('.current');
                        
                        console.log(el);
                    }

                }
                parent.find('.SliderProdotto2023__wrap__items').animate({scrollLeft: '-='+width_move}, 400);
            }else {
                console.log('button_next');
                if(current_item.next().length == 1){
                    //console.log(current_item.next());
                    var el = current_item.next();
                    current_item.removeClass('current');
                    el.addClass('current');
                    
                }else {

                    if (parent_cat.next().length == 1) {
                        parent_cat.removeClass('active');
                        parent_cat = parent_cat.next().addClass('active');
                        var parent_cat_id = parent_cat.data('catid');
                        $('.ListsProducts').find("[data-id='" + parent_cat_id + "']").addClass('active').siblings().removeClass('active');
                        var el = parent_cat.find('.current');
                        
                        console.log(el);
                    }

                }

                parent.find('.SliderProdotto2023__wrap__items').animate({scrollLeft: '+='+width_move}, 400);
            }
            //el[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
            

        });	
        var position_cat = {};
        $('.SliderProdotto2023__wrap__items__category').each(function(){
            
            position_cat[$(this).data('catid')] = $(this).position().left;
        })

        //console.log(position_cat);
        $(document).on('click','.ac-ls-dropdown-select', function() {
            var $this = $(this);
            console.log($this);
            var parent = $this.parent();
            if(parent.hasClass('select-collapsed')){
                parent.removeClass('select-collapsed');
            }
        });
        $(document).on('click','.open-list', function() {
            
            console.log('active');
            var modale = $('.Modal');
            if(!modale.hasClass('active')){
                modale.addClass('active');
            }
        });
        $(document).on('click','.active_lang', function() {
            
            console.log('active');
            var modale = $('.list_lang');
            if(!modale.hasClass('active')){
                modale.addClass('active');
            }
        });
        $(document).on('click','.close_modal', function() {
            
            var modale = $('.Modal');
            if(modale.hasClass('active')){
                modale.removeClass('active');
            }
        });

        jQuery("body").click(function(e){ 
            var target = jQuery(e.target); 
            //console.log(target);
                

           
            if(e.target.classList.contains("ac-ls-dropdown-select")){
                console.log('attivo');
                //$('.Megamenu__content__desktop').removeClass('active');
            }else {
                //console.log('tutti gli latri');
                $('.ac-ls-dropdown').addClass('select-collapsed');
            }
            if(e.target.classList.contains("active_lang")){
                console.log('attivo');
                //$('.Megamenu__content__desktop').removeClass('active');
            }else {
                //console.log('tutti gli latri');
                $('.list_lang').removeClass('active');
            }
            
        });

        $(document).on('click','.ListsProducts .list-click-grid', function() {
            var $this = $(this);
            var current = $this.data('id');

            $(this).addClass('active');
            $(this).siblings().removeClass('active');

            if(current) {
                var el = $this.parents('.SliderProdotto2023').find("[data-catid='" + current + "']"); 
                el.siblings().removeClass('active');
                el.addClass('active');
            }

        });	
        $(document).on('click','.ListsProducts .list-click', function() {	
        //var el = document.querySelector('.special');
        

            var $this = $(this);
            var current = $this.data('id');

            $(this).addClass('active');
            $(this).siblings().removeClass('active');

            

            //console.log($this);
            //console.log(current);
            if(current) {
                var el = $this.parents('.SliderProdotto2023').find("[data-catid='" + current + "']");
                var el_left = el.position();

                
                console.log(el_left.left);
                console.log(width_move);
                
                var current_cat = $this.parents('.SliderProdotto2023').find("[data-catid='" + current + "']").addClass('active');
                current_cat.find('.SliderProdotto2023__wrap__items__category__item').removeClass('current');
                current_cat.find('.SliderProdotto2023__wrap__items__category__item').first().addClass('current');


                $this.parents('.SliderProdotto2023').find("[data-catid='" + current + "']").siblings().removeClass('active');
                
                //console.log(el[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' }));
                //$('.SliderProdotto2023__wrap__items').scrollLeft(el_left.left);
                
                $this.parents('.SliderProdotto2023').find('.SliderProdotto2023__wrap__items').animate({scrollLeft: (position_cat[el.data('catid')] - 8) }, 800);
                
                //el[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                /*
                $("html, body").animate({
                    scrollTop: '+=10'
                }, 600);
                */

                
            }
            
        });

        
        
        

       
    });
})(jQuery);

